module.exports = __webpack_public_path__ + "img/dsci0157.b070696e.jpg";